import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'admin' })
export class AdminPipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    let result = null;
    switch (obj) {
      case 'ADMIN':
        result = '원청담당자';
        break;
      case 'USER':
        result = '그룹담당자';
        break;
    }
    return result;
  }
}
